import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface InvoiceEntityParams {
  created_at: string;
  due_date: string;
  status: string;
  distributor: string;
  amount_due: number;
  retailer_id: number;
  provi_order_id: number;
  delivery_date: string;
  invoice_id: number;
  in_provi_pay: boolean;
}
export class InvoiceEntity extends BaseEntityClass {
  created_at: string;
  due_date: string;
  status: string;
  distributor: string;
  amount_due: number;
  retailer_id: number;
  provi_order_id: number;
  delivery_date: string;
  invoice_id: number;
  in_provi_pay: boolean;
  constructor(params: InvoiceEntityParams) {
    super();
    this.type = "invoice";
    this.entity_version = 2;
    this.created_at = params.created_at;
    this.due_date = params.due_date;
    this.status = params.status;
    this.distributor = params.distributor;
    this.amount_due = params.amount_due;
    this.retailer_id = params.retailer_id;
    this.provi_order_id = params.provi_order_id;
    this.delivery_date = params.delivery_date;
    this.invoice_id = params.invoice_id;
    this.in_provi_pay = params.in_provi_pay;
  }
}
